import React from "react"
import { Link } from "gatsby"
import Img from "gatsby-image"
import Markdown from "../Markdown"

import style from "./index.module.css"

class Article extends React.Component {
  render() {
    const article = this.props.article;
    return (
      <article key={article.id} className={style.article}>
        <Link to={`/update/${article.slug}/`}>
          <Img className={style.image} fluid={article.imageOverview.fluid} />
          <div className={style.textContainer}>
            <h1 className={style.title}>{article.title}</h1>
            {article.description.description &&
              <Markdown source={article.description.description} softBreak="br" className={style.description} />
            }
          </div>
        </Link>
      </article>
    )
  }
}

export default class ArticleList extends React.Component {
  render() {
    var articles = this.props.articles;
    var edges = articles.edges ? true : false;
    return (
      <div className={style.list}>
        {edges && articles.edges.map(({ node }) => {
          return (
            <Article article={node} key={node.id} />
          )
        })}
        {!edges && articles.map((node, index) => {
          return (
            <Article article={node} key={node.id} />
          )
        })}
      </div>
    )
  }
}